export class AbcTileNav {
  caption?: string;
  name: string;
  disabled?: boolean;
  data?: any;
  size?: 'small' | 'normal' = 'normal';

  constructor(
    caption: string,
    name: string,
    disabled?: boolean,
    data?: {},
  ) {
    this.caption = caption;
    this.name = name;
    this.disabled = disabled;
    this.data = data;
  }
}
